/**
 * Header Utility Functions
 * 
 * Shared utility functions for header component including route configuration
 * and title derivation.
 */

/**
 * Get route configuration for page titles and search placeholders
 */
export const getRouteConfig = (t) => ({
  '/': { title: t('dashboard', { ns: 'common' }), search: t('searchInvoices', { ns: 'dashboard' }) },
  '/dashboard': { title: t('dashboard', { ns: 'common' }), search: t('searchInvoices', { ns: 'dashboard' }) },
  '/collections': { title: t('collections', { ns: 'common' }), search: t('searchTransactions', { ns: 'collections' }) },
  '/disbursements': { title: t('disbursements', { ns: 'common' }), search: t('searchPayouts', { ns: 'disbursements' }) },
  '/invoicing': { title: t('invoicing', { ns: 'common' }), search: t('searchPlaceholder', { ns: 'common' }) },
  '/expenses': { title: t('sms', { ns: 'common' }), search: t('searchPlaceholder', { ns: 'common' }) },
  '/payroll': { title: t('payroll', { ns: 'common' }), search: t('searchEmployees', { ns: 'payroll' }) },
  '/reports': { title: t('reports', { ns: 'common' }), search: t('searchPlaceholder', { ns: 'common' }) },
  '/settings': { title: t('settings', { ns: 'common' }), search: t('searchPlaceholder', { ns: 'common' }) },
});

/**
 * Derives page title from URL pathname
 */
export const deriveTitleFromPath = (pathname, t) => {
  const routeConfig = getRouteConfig(t);
  if (routeConfig[pathname]?.title) {return routeConfig[pathname].title;}
  if (pathname === '/' || pathname === '') {return t('dashboard', { ns: 'common' });}
  const segments = pathname.split('/').filter(Boolean);
  const last = segments[segments.length - 1] || t('dashboard', { ns: 'common' });
  return last
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

/**
 * Get user's first name from user data
 */
export const getUserFirstName = (userData) => {
  if (userData) {
    const userType = userData.usertype?.toLowerCase() || userData.user_type?.toLowerCase();
    const isBusiness = userType === 'business_contact' || userType === 'business_member' || userType === 'business';
    if (isBusiness) {
      const bizName = userData.business?.trading_name ||
        userData.business?.business_name ||
        userData.business_name ||
        userData.trading_name ||
        userData.businesses?.[0]?.trading_name ||
        userData.businesses?.[0]?.business_name;
      if (bizName) { return bizName; }
    }
    if (userData.first_name) {return userData.first_name;}
    if (userData.firstName) {return userData.firstName;}
    if (userData.name) {return userData.name.split(' ')[0];}
    if (userData.full_name) {return userData.full_name.split(' ')[0];}
    if (userData.email) {return userData.email.split('@')[0];}
  }
  return 'User';
};

